<div class="main-container">
  <div #imageContent class="subject-cad-wrapper" *ngIf="subjectModel"  [ngClass]="{ 'hidden-height': !isSubjectImageOpen }">
  <!--subject model locations area layer-->
    <div class="locations-layer" [class.image-expand]="!isSubjectImageOpen">

      <!-- area -->

        <div #subjectCad class="subject-cad-name" [class.fixed]="isSubjectImageOpen"
          [ngClass]="{ 'no-subject-image' : !structImageSrc }" (click)="clickSubjectImageHide()"
          [matTooltip]="subjectModel?.name" matTooltipClass="tooltip-overflow">
          <evc-svg-icon id="eye-icon" size="md" icon="visibility-show"></evc-svg-icon>
          <span class="inspection-title">{{inspection.title}}</span>
          <evc-svg-icon id="expand-icon" [class.rotated]="isSubjectImageOpen" *ngIf="structImageSrc" size="md" icon="angle-down"></evc-svg-icon>
        </div>

    </div>

    <svg [attr.viewBox] ="viewBox" class="subject-cad-image"  [ngClass]="{ 'hidden-image': !isSubjectImageOpen || !structImageSrc }" preserveAspectRatio="xMidYMid meet">
      <image [attr.href]="structImageSrc" x="0" y="0" [attr.width]="imageWidth" [attr.height]="imageHeight"  preserveAspectRatio="xMidYMid meet" style="pointer-events: none;"></image>
      <g [class.image-hide]="!isSubjectImageOpen"  pointer-events="bounding-box">
        <rect *ngFor="let location of subjectLocations" class="location-area element"
        [class.locationSelected]="filterLocation === location"
        (click)="selectGlobalLocation(location)"
        rx="8"
        ry="8"
        attr.y="{{location.rectInStructImage.top * imageHeight / 100}}"
        attr.x="{{location.rectInStructImage.left * imageWidth / 100}}"
        attr.width="{{location.rectInStructImage.width * imageWidth/100}}"
        attr.height="{{location.rectInStructImage.height * imageHeight/100}}"
        [class.image-hide]="!isSubjectImageOpen"
        [class.selected]="filterLocation === location"
        (click)="selectGlobalLocation(location)">
      </rect>
      </g>
    </svg>
  </div>

<!-- inspection-menu-content-->
  <ng-container>
    <div #menu class="sticky-header content">

      <!-- Images Filters -->
      <div class="inspection-menu-content">

        <div class="left-content">

          <app-checkbox
            [checked]="isSelectedImageAll4Select()"
            *ngIf="inspectionImages.length > 0 || !isDataPlateOnly()"
            (checkedChange)="selectImageAll4Select()">
          </app-checkbox>

          <ng-container
            *ngIf="inspectionImages.length > 0 && isImageSelected || (inspectionReport && isContainLocations())"
            class="line">
            <div class="vertical-bar"></div>

            <evc-nav-button
              *ngIf="isImageSelected"
              type="tertiary"
              size="sm"
              variant="semi"
              [leftIcon]="trashCanIcon"
              (click)="openMultipleDeleteDialog()">
              {{ 'inspectionDataManagement.delete' | translate }}
            </evc-nav-button>

            <evc-nav-button
              *ngIf="canEditInspection() && (isImageSelected || isContainDataplateImageSelected() || isContainUploadingImageSelected())"
              type="tertiary"
              size="sm"
              variant="semi"
              [leftIcon]="penToSquareIcon"
              (click)="openMultipleImageEditDialog()">
              {{ 'inspectionDataManagement.edit' | translate }}
            </evc-nav-button>

            @if (isBrianMode){
              <evc-nav-button
                *ngIf="canEditInspection() && singleImageSelected"
                type="tertiary"
                size="sm"
                variant="semi"
                [leftIcon]="'file-export'"
                (click)="exportCompareImage()">
                {{ 'inspectionDataManagement.compareImage' | translate}}
              </evc-nav-button>
            }

            <div
              class="select-all"
              *ngIf="inspectionReport && getNumberOfStillInspectionImage() > 0 && isContainLocations() && canEditInspection() && validateStatus()">
              <evc-nav-button
                type="tertiary"
                size="sm"
                variant="semi"
                [leftIcon]="fileExportIcon"
                (click)="selectImageAll4Report($event)">
                {{ 'inspectionDataManagement.selectAllForReport' | translate }}
              </evc-nav-button>
            </div>
          </ng-container>

          @if (IsAdminOrInspectionOwner) {
            <!-- Conditional Section for Selected Location -->
            <div *ngIf="selectedLocation" class="edit-section-summary">
              <div class="vertical-bar" *ngIf="inspectionImages.length > 0"></div>
              <evc-nav-button
                class="link-button"
                type="tertiary"
                variant="square"
                leftIcon="pen-to-square"
                size="sm"
                [disabled]="!selectedLocation"
                (ctaClicked)="openEditSectionCommentDialog()">
                {{ 'inspectionDataManagement.editSelection' | translate }}
              </evc-nav-button>
            </div>
          }

          <!-- Marks Filter Form -->
          <div
            class="marks-filter-form"
            *ngIf="inspectionImages.length > 0 || hasMarkFilters">
            <div class="marks-filter-inner">
              <app-mark-filter
                (filterChange)="loadImages()"
                [filterMarkControl]="filterMarkControl"
                >
              </app-mark-filter>
            </div>
          </div>
        </div>

        <div class="right-content">

          <div class="checkbox-container" *ngIf="isBrianMode">
            <input
              class="brian-sync-checkbox"
              type="checkbox"
              [checked]="inspection.id === brianSynchronizedInspectionId"
              id="synchronization-checkbox"
              (change)="updateBrianSynchronizedInspection()"
            />
            <label class="brian-sync-label" for="synchronization-checkbox">
              {{ 'inspectionUpsertDialog.brianSynchronization' | translate }}
            </label>
          </div>

          @if (IsAdminOrInspectionOwner){
            <evc-nav-button
              id="upload-button"
              type="icon"
              leftIcon="download"
              size="sm"
              [matTooltip]="'inspectionDataManagement.import' | translate"
              (ctaClicked)="openUploadImageDialog()">
            </evc-nav-button>
          }

          <evc-nav-button
            id="information-button"
            type="icon"
            size="sm"
            leftIcon="circle-info"
            [matTooltip]="'inspectionDataManagement.information' | translate"
            (ctaClicked)="openInspectionInfoDialog()">
          </evc-nav-button>

          <evc-nav-button
              *ngIf="canDisplayExportInspectionButton"
              id="export-button"
              type="icon"
              size="sm"
              leftIcon="upload"
              [matTooltip]="'inspectionDataManagement.exportInspection' | translate"
              (ctaClicked)="openExportInspection()">
          </evc-nav-button>
        </div>

      </div>

    </div>
  </ng-container>

<div class="inspection-images-content content">
  <div fxLayout="column">

    <div *ngIf="this.selectedLocation?.children.length > 0" class="parent-location summary-content">
      <div class="inspection-image-location">{{ this.selectedLocation.name }}</div>
      <div class="summary-comment">{{ summaryComment }}</div>
    </div>
    <!--inspection image-->
    <div *ngFor="let displayImageList of imagesGroupedByLocation; let locIndex=index" fxLayout="column" [class.location-group]="displayImageList.images.length > 0 ">
      <div *ngIf="displayImageList.images.length > 0 || imagesGroupedByLocation.length === 1"
        appUploadInspectionFiles
        [locationId]="displayImageList.locationId"
        [inspectionId]="inspection.id"
        [uploadDisabled]="!canEditImage || isImageSelected"
        (drop)="changeOrder(locIndex, displayImageList.locationId)"
        (dragstart)="onDragStart()"
        (dragend)="onDragEnd()"
        >
        <div class="inspection-image-location">{{ displayImageList.displayLocationName }}</div>
        <div *ngIf="this.inspection.id && this.selectedLocation?.children.length === 0" class='summary-content'>{{summaryComment}}</div>
        <div fxLayout="row wrap" fxLayoutGap="1rem" class="inspection-cards" >
          <div *ngFor="let inspectionImage of displayImageList.images; let imgIndex=index; trackBy:trackByImageItem" class="image-card">
            <div>
              <app-inspection-image-card
                [draggable]="isSelectedImage4Select(inspectionImage)"
                (dragover)="onDragOver(imgIndex, $event)"
                [marks]="marks"
                [inspectionImage]="inspectionImage"
                [isSelected]="isSelectedImage4Select(inspectionImage)"
                [canEditImage]="canEditImage"
                [selectModeEnabled]="isImageSelected"
                [isSelectedForReport]="isSelectedImage4Report(inspectionImage)"
                [havePermissionOnReport]="havePermissionOnReport"
                [selectForReportModeEnabled]="isShowSelectedIcon(inspectionImage)"
                (editImage)="openInspectionImageEditDialog($event)"
                (selectCard)="selectImage4Select($event)"
                (deleteImage)="deleteSingleImage($event)"
                (selectImageForReport)="selectImage4Report($event, true)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- placehodler upload card -->
     @if (IsAdminOrInspectionOwner){
       <div class="media-card" (click)="openUploadImageDialog()" *ngIf="inspectionImages.length === 0 && !this.selectedLocation">
         <evc-svg-icon class="icon" icon="download"></evc-svg-icon>
         <div class="text">{{ 'inspectionDataManagement.importAsUploadPlaceholderCard' | translate }}</div>
       </div>
     }
  </div>
</div>
